export function checkObjWithNameProp<T>(obj: unknown, name: string): obj is T {
  return typeof obj === 'object' && obj !== null && name in obj;
}
